function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTether(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0EFEB"
    },
    d: "M302.916,217.83v-57.051h134.332V72.035h-367v88.743H204.57v57.271 c-108.502,5.548-189.785,28.285-189.785,55.495c0,27.209,81.283,49.946,189.785,55.495v177.789C221.184,510.224,238.383,512,256,512 c16.029,0,31.713-1.473,46.916-4.294V329.258c110.759-5.141,194.299-28.129,194.299-55.714S413.675,222.971,302.916,217.83z  M256,308.611c-121.031,0-219.146-18.233-219.146-40.73c0-19.205,71.502-35.307,167.717-39.602v65.233 c16.311,2.351,32.747,3.532,49.173,3.532c16.436,0,32.872-1.181,49.173-3.532V228.08c98.482,4.002,172.22,20.292,172.22,39.8 C475.136,290.377,377.02,308.611,256,308.611z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTether);
export default __webpack_public_path__ + "static/media/Tether.b88c40c6.svg";
export { ForwardRef as ReactComponent };